import * as angular from "angular";
import {IController} from "angular";
import {BranchesAlerts} from "../../services/branches-alerts.service";
import {BranchesDialogService} from "../../services/branches-dialogs-service.service";
import {BranchesRequests} from "../../services/branches-requests.service";
import {BranchModel} from "../../models/branch.model";
import {GroupModel} from "../../../groups/models/group.model";
import {GroupsHttpService} from "../../../groups/angular/services/groups-http.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {BranchesService} from "../../services/branches-service.service";

export class branchDetailsCtrl implements IController {

  branch: BranchModel;

  private loading = false;
  private planningOpen: any;
  public branchGroups: GroupModel[];

  /* @ngInject */
  constructor(private $state, private $mdSidenav, private branchesDialogService: BranchesDialogService,
              private branchesRequests: BranchesRequests, private branchesAlerts: BranchesAlerts, private $log,
              private $groups, private groupsHttpService: GroupsHttpService,
              private commonsDialogService: CommonsDialogService, private branchesService: BranchesService) {
  }

  $onInit() {
    this.groupsHttpService.getGroups({
      branchId: this.branch.id,
      limit: 1000
    }).subscribe((res) => {
      this.branchGroups = res.list;
    })
    this.planningOpen = this.$state.current.name.match('planning');
  }

  onEditInfo(event) {
    this.branchesDialogService.editBranch(event, this.branch)
      .then((editedBranch) => {
        this.loading = true;
        return this.branchesRequests.editBranch(this.branch.id, editedBranch)
      })
      .then((updatedBranch) => {
        this.branch = updatedBranch;
        this.branchesAlerts.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.branchesAlerts.updateError();
          this.$log.error('Failed to update branch info @branchDetails@onEditInfo', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  openEditExternalId() {
    this.commonsDialogService.editExternalId(this.branch.externalId)
      .then((externalId) => {
        const branchCopy = angular.copy(this.branch);
        branchCopy.externalId = externalId

        this.branchesService.updateExternalId(this.branch.id, branchCopy).then((branch) => {
          this.branch = branch;
        });
      })
  }

  toggleSidenav(event) {
    this.$mdSidenav('closeEventsDisabled').toggle();
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchDetails', {
    bindings: {
      branch: '<'
    },
    template: require('./branch-details.html').default,
    controller: branchDetailsCtrl
  });
